import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/index';

const store = configureStore({
  devTools: true,
  reducer: rootReducer,
});

export default store;
